import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const LiveSignalsPage = lazy(() => import('../pages/live-signals/page'));
const GlossaryPage = lazy(() => import('../pages/glossary/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const VerifyPage = lazy(() => import('../pages/auth/verify/page'));
const AccountPage = lazy(() => import('../pages/account/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/product',
    element: <ProductPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/live-signals',
    element: <LiveSignalsPage />,
  },
  {
    path: '/glossary',
    element: <GlossaryPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/auth/verify',
    element: <VerifyPage />,
  },
  {
    path: '/account',
    element: <AccountPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
